module.exports = ['$scope', '$timeout', 'locale', function($scope, $timeout, locale) {
  const language = locale.isFrench() ? 'fr' : 'en';
  $scope.countries = null;
  this.selectCountryText = locale.isFrench() ? 'Choisissez le pays' : 'Select Country';
  
  const postRequire = r => // $timeout ensures we don't create a digest loop problem
    $timeout(function() {
      let countries = _.map(Object.keys(r.getAlpha3Codes()), c => {
        if (c !== 'CAN' && c !== 'USA') {
          return {
            code: c,
            name: r.getName(c, language)
          };
        }
        return false;
      });
      countries = countries.filter(Boolean);
      countries = countries.sort((a, b) => a.name.localeCompare(b.name));
      return $scope.countries = countries;
    });

  const countries = require('i18n-iso-countries');
  const enCountryLabels = require('i18n-iso-countries/langs/en.json');
  const frCountryLabels = require('i18n-iso-countries/langs/fr.json');

  countries.registerLocale(enCountryLabels);
  countries.registerLocale(frCountryLabels);

  $scope.$on('canceled', function() {
    setTimeout(() => {
      if($scope.addCountries && Array.isArray($scope.$parent.model) && $scope.$parent.model.length) {
        $scope.addCountries($scope.$parent.model.map((code) => ({ code, name: countries.getName(code, language) })));
      }
    }, 1);
  });

  $scope.$watch('$scope.$parent.model', (value) => {
    if($scope.addCountries && Array.isArray($scope.$parent.model) && $scope.$parent.model.length) {
      $scope.addCountries($scope.$parent.model.map((code) => ({ code, name: countries.getName(code, language) })));
    }
  });
  
  postRequire(countries);

  return this;
}];
